import type { InjectionKey, Ref } from 'vue'

export type TabRegistration = {
  title: string,
  selected: boolean,
  isActive: boolean,
  tabIndex: number
}

export type TabContainerContext = {
  registerTab: (tab: TabRegistration) => void,
  unregisterTab: (tab: TabRegistration) => void,
  containerId: Ref<string | null>
}

export const TabContainerKey: InjectionKey<TabContainerContext> = Symbol('TabContainer')
